import styled from "@emotion/styled";
import { darkColors } from "../../../theme/colors";
import { fontSizes } from "../../../theme/font-sizes";
import { TableContainer, TableRow } from "@mui/material";

export const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  backgroundColor: "transparent",
  "& .MuiTableCell-root": {
    borderBottom: "none",
    color: "#fff",
    padding: "14px",
    paddingLeft: 56,
    // paddingBottom: 30,
  },
  "& .MuiTableHead-root .MuiTableCell-root": {
    backgroundColor: "transparent",
    color: darkColors.tableGray,
    fontWeight: 700,
    fontSize: fontSizes.body,
  },
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  backgroundColor: "transparent",
  borderRadius: "12px",
  "& td:first-of-type": {
    borderTopLeftRadius: "12px",
    borderBottomLeftRadius: "12px",
  },
  "& td:last-child": {
    borderTopRightRadius: "12px",
    borderBottomRightRadius: "12px",
  },
  "&:nth-of-type(odd)": {
    backgroundColor: darkColors.background,
  },
  marginBottom: "8px",
}));

export const StyledProfileTableRow = styled(TableRow)(({ theme }) => ({
  backgroundColor: darkColors.background,

  "&:nth-of-type(odd)": {
    backgroundColor: "#1E1E1E",
  },
  marginBottom: "8px",
}));
